import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import { useAemConfig } from '@as-react/common-components';
import { Cookie } from '@as-react/common-types';
import { CookieUtil } from '@as-react/common-utils';
import { useDispatch } from 'react-redux';
import { getQuerystringByName } from '../util/URLParamUtil';
import LocalStorageUtil from '../util/LocalStorageUtil';
import StoreAPI from '../api/store/StoreAPI';
import BasketAPI from '../api/basket/BasketAPI';
import { DEVICE_ID_STORAGE_KEY, PERSONAL_SHOPPING_ADVICE_STORAGE_KEY, SHOP_NUMBER_STORAGE_KEY, } from '../constants/StorageKeysConstants';
import sessionActions from '../redux/session/actions/SessionActions.creators';
const ShopNumberContainer = () => {
    const { defaultRequestParams, servicesEndpoint, shopNumber, isShopLanding } = useAemConfig();
    const [localShopNumber, setLocalShopNumber] = useState('');
    const dispatch = useDispatch();
    const setShopLocationInCookie = () => __awaiter(void 0, void 0, void 0, function* () {
        const storeInfo = yield StoreAPI.getShopLandingStoreInfo(servicesEndpoint, defaultRequestParams, shopNumber);
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.latitude) && (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.longitude)) {
            CookieUtil.set(Cookie.BROWSER_GEOLOCATION, encodeURIComponent(JSON.stringify({ lat: storeInfo.latitude, lng: storeInfo.longitude })), {
                secure: true,
            });
        }
    });
    const setDeviceIdInLocalStorage = () => {
        const deviceIdParam = getQuerystringByName(window.location.search, DEVICE_ID_STORAGE_KEY) ||
            getQuerystringByName(window.location.hash, DEVICE_ID_STORAGE_KEY);
        if (deviceIdParam) {
            LocalStorageUtil.setItem(DEVICE_ID_STORAGE_KEY, deviceIdParam);
        }
    };
    const setPersonalShoppingAdviceInLocalStorage = () => {
        const personalShoppingAdviceParam = getQuerystringByName(window.location.search, PERSONAL_SHOPPING_ADVICE_STORAGE_KEY) ||
            getQuerystringByName(window.location.hash, PERSONAL_SHOPPING_ADVICE_STORAGE_KEY);
        if (personalShoppingAdviceParam) {
            LocalStorageUtil.setItem(PERSONAL_SHOPPING_ADVICE_STORAGE_KEY, personalShoppingAdviceParam.toLowerCase().trim());
        }
    };
    const checkForShopNumber = () => {
        const shopNumberValue = getQuerystringByName(window.location.search, SHOP_NUMBER_STORAGE_KEY) ||
            getQuerystringByName(window.location.hash, SHOP_NUMBER_STORAGE_KEY) ||
            LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY);
        if (shopNumberValue) {
            SITE.Config.shopNumber = shopNumberValue;
            setLocalShopNumber(shopNumberValue);
            LocalStorageUtil.setItem(SHOP_NUMBER_STORAGE_KEY, shopNumberValue);
            BasketAPI.initiateBasketForShopLanding(servicesEndpoint, defaultRequestParams, shopNumberValue);
        }
    };
    useEffect(() => {
        checkForShopNumber();
        setDeviceIdInLocalStorage();
        setPersonalShoppingAdviceInLocalStorage();
        dispatch(sessionActions.createInitAction());
    }, []);
    useEffect(() => {
        if (isShopLanding && localShopNumber) {
            setShopLocationInCookie();
        }
    }, [localShopNumber]);
    return null;
};
export default ShopNumberContainer;
